module.exports = __webpack_public_path__ + "img/save.486a5d2d.svg";